import Vue from "vue";
import App from "./App.vue";
import router from "./routers";
import store from "./store";
import "./styles/tailwindcss.css"
import '@/styles/main.scss';
Vue.config.productionTip = false;

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import i18n from './i18n/i18n.js';

new Vue({
  router,
  store,
  i18n, //很重要，别忘记
  render: (h) => h(App),
}).$mount("#app");
